import { api, apiHolder, apis } from 'api';
import { debounceMailListRequest } from '@web-mail/utils/debounceRequest';
const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const mailPlusCustomerApi = apiHolder.api.requireLogicalApi(apis.mailPlusCustomerApiImpl);
const contactApi = api.requireLogicalApi(apis.contactApiImpl);
const debounceRequestGroupWarp = debounceMailListRequest();
const doListMailBoxEntities = debounceRequestGroupWarp(mailApi.doListMailBoxEntities.bind(mailApi), 'doListMailBoxEntities');
const doListMailBoxEntitiesFromDB = debounceRequestGroupWarp(mailApi.doListMailEntitiesFromDb.bind(mailApi), 'doListMailEntitiesFromDb');
const doSearchCustomerPage = debounceRequestGroupWarp(mailPlusCustomerApi.doSearchCustomerPage.bind(mailPlusCustomerApi), 'doSearchCustomerPage');
const doCustomersUnread = mailApi.doCustomersUnread.bind(mailApi);
const doGetTpMailContent = mailApi.doGetTpMailContent.bind(mailApi);
const doGetColleagueList = contactApi.doGetColleagueList.bind(contactApi);
const doGetResignList = contactApi.doGetResignList.bind(contactApi);
const doGetColleagueFolderList = contactApi.doGetColleagueFolderList.bind(contactApi);
const doGetColleaguePromotion = contactApi.doGetColleaguePromotion.bind(contactApi);
const doUpdateColleaguePromotion = contactApi.doUpdateColleaguePromotion.bind(contactApi);
const doGetCustomerGroupList = mailPlusCustomerApi.doGetMyCustomerGroupList.bind(mailPlusCustomerApi);
const doGetGroupRequestParams = mailPlusCustomerApi.doGetGroupRequestParams.bind(mailPlusCustomerApi);
const doGetMyCustomerGroup1CountList = mailPlusCustomerApi.doGetMyCustomerGroup1CountList.bind(mailPlusCustomerApi);
const doGetCustomerList = mailPlusCustomerApi.doGetMyCustomerByGroup.bind(mailPlusCustomerApi);
const doGetCustomerContactList = mailPlusCustomerApi.doGetContactListByCompanyId.bind(mailPlusCustomerApi);
const doGetColleagueRelationList = mailPlusCustomerApi.doGetColleagueRelationList.bind(mailPlusCustomerApi);
const doGetColleagueUnFollowNumber = mailPlusCustomerApi.doGetColleagueUnFollowNumber.bind(mailPlusCustomerApi);
export const request = {
    doListMailBoxEntities,
    doListMailBoxEntitiesFromDB,
    doGetTpMailContent,
    doSearchCustomerPage,
    doCustomersUnread,
    doGetColleagueList,
    doGetResignList,
    doGetColleagueFolderList,
    doGetColleaguePromotion,
    doUpdateColleaguePromotion,
    doGetCustomerGroupList,
    doGetGroupRequestParams,
    doGetCustomerList,
    doGetCustomerContactList,
    doGetMyCustomerGroup1CountList,
    doGetColleagueRelationList,
    doGetColleagueUnFollowNumber,
};
